/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { createActions } from 'redux-actions';
import { ROOT_SLICE } from '../constants';

const {
	setMessages,
	setIsLoadingLoadedMessages,
	setHasLoadingError,
	deleteMessage,
	deleteMessages,
} = createActions(
	{
		SET_MESSAGES: messages => ({ messages }),
		SET_IS_LOADING_LOADED_MESSAGES: ({
			isLoadingMessages,
			isLoadedMessages
		}) => ({ isLoadingMessages, isLoadedMessages }),
		SET_HAS_LOADING_ERROR: hasError => ({ hasError }),
		DELETE_MESSAGE: (message) => ({ message }),
		DELETE_MESSAGES: (messages) => ({ messages }),
	},
	{ prefix: ROOT_SLICE }
);

export {
	setMessages,
	setIsLoadingLoadedMessages,
	setHasLoadingError,
	deleteMessage,
	deleteMessages
};
